export default __webpack_public_path__ + "static/03-ac246936dc480c2be758e7f85512d564.jpg";